// extracted by mini-css-extract-plugin
module.exports = {"contents":"contents_1rune","studentsTable":"studentsTable_9wqc4","tabList":"tabList_5jayf"};